import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const ESFlag = createIcon({
  displayName: "ESFlag",
  viewBox: "0 0 96 64",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Spain flag </title>
      <path d="M95 0H0V16.2677H95V0Z" fill="#D80F15" />
      <path d="M95 16.2677H0V47.7296H95V16.2677Z" fill="#FFCD2F" />
      <path d="M95 47.7323H0V64H95V47.7323Z" fill="#D80F15" />
      <path
        d="M21.1027 27.4681H14.3061V35.2208H21.1027V27.4681Z"
        fill="#D80F15"
      />
      <path
        d="M27.8992 27.4681H21.1027V35.2208H27.8992V27.4681Z"
        fill="#FEFEF8"
      />
      <path
        d="M27.8992 35.2209V38.9429C27.8992 42.7203 24.8561 44.2002 21.1027 44.2002V35.2209H27.8992Z"
        fill="#D80F15"
      />
      <path
        d="M21.1027 35.2209V44.2002C17.3492 44.2002 14.3061 42.7203 14.3061 38.9429V35.2209H21.1027Z"
        fill="#C8A238"
      />
      <path
        d="M30.8664 27.4681H28.8743V44.2001H30.8664V27.4681Z"
        fill="#FEFEF8"
      />
      <path
        d="M29.8703 42.2851C30.8165 42.2851 31.5871 43.058 31.5871 44.0129V44.2002H28.1561V44.0129C28.1561 43.0606 28.9241 42.2851 29.8729 42.2851H29.8703Z"
        fill="#C8A238"
      />
      <path
        d="M13.4228 27.4681H11.4307V44.2001H13.4228V27.4681Z"
        fill="#FEFEF8"
      />
      <path
        d="M12.4267 42.2851C13.373 42.2851 14.1436 43.058 14.1436 44.0129V44.2002H10.7125V44.0129C10.7125 43.0606 11.4805 42.2851 12.4294 42.2851H12.4267Z"
        fill="#C8A238"
      />
      <path
        d="M16.9875 26.6531L13.7609 22.9231L21.1027 20.6361L28.4444 22.7991L25.2991 26.6531H16.9875Z"
        fill="#D80F15"
      />
      <path
        d="M21.1027 19.3013L20.2744 20.615L21.1027 21.5145L21.8942 20.615L21.1027 19.3013Z"
        fill="white"
      />
      <path
        d="M21.1027 36.9487C22.0509 36.9487 22.8195 36.1751 22.8195 35.2208C22.8195 34.2666 22.0509 33.493 21.1027 33.493C20.1545 33.493 19.3858 34.2666 19.3858 35.2208C19.3858 36.1751 20.1545 36.9487 21.1027 36.9487Z"
        fill="#214798"
      />
    </>
  )
});
